import { z } from 'zod';
export const createSiteSchema = z.object({
    name: z.string().trim().min(1, 'Site name is required'),
});
export const updateSiteSchema = z.object({
    name: z.string().trim().min(1).optional(),
});
//# sourceMappingURL=site.schemas.js.map